var React = require('react');

function Reorder (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"v3-(Final)","stroke":"none","strokeWidth":"1","fill":"none","fillRule":"evenodd","strokeLinecap":"square"},React.createElement("g",{"id":"HSL-Builder-22","transform":"translate(-90.000000, -356.000000)","stroke":"#333333"},React.createElement("g",{"id":"Material/Light/replace","transform":"translate(87.000000, 349.000000)"},[React.createElement("path",{"d":"M4,12 L20,12","id":"Line","key":0}),React.createElement("path",{"d":"M4,8 L20,8","id":"Line","key":1}),React.createElement("path",{"d":"M4,16 L20,16","id":"Line","key":2})]))));
}

Reorder.defaultProps = {"width":"18px","height":"10px","viewBox":"0 0 18 10","version":"1.1"};

module.exports = Reorder;

Reorder.default = Reorder;
